import { render } from "./ServiceClientView.vue?vue&type=template&id=ae3cb7e2&scoped=true&ts=true"
import script from "./ServiceClientView.vue?vue&type=script&lang=ts"
export * from "./ServiceClientView.vue?vue&type=script&lang=ts"

import "./ServiceClientView.vue?vue&type=style&index=0&id=ae3cb7e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae3cb7e2"]])

export default __exports__